const LISTE_PRODUIT_ECRAN = {
  breadcrumb: {
    racine: 'Accueil',
    liste: 'Liste des produits Ecran Numérique',
  },
  actions: {
    add: 'Nouveau produit écran Numérique',
    edit: 'Modifier',
    archiver: 'Archiver',
    desarchiver: 'Désarchiver',
    delete: 'Supprimer',
  },
  archivage: {
    archiver: 'Etes-vous sûr de vouloir archiver ce produit ?',
    desarchiver: 'Etes-vous sûr de vouloir désarchiver ce produit ?',
    yes: 'Oui',
    no: 'Non',
    sucessArchivage: 'Produit archivé avec succès',
    successDesarchivage: 'Produit désarchivé avec succès',
  },
  tabs: {
    title: 'Liste des produits Ecran Numérique',
    reference: 'Référence',
    adresse: 'Adresse',
    image: 'Image',
    codePostal: 'CP',
    ville: 'Ville',
    departement: 'Dpt.',
    format: 'Format',
    materiel: 'Matériel',
    support: 'Support',
    affectation: 'Affectation com.',
    societe: 'Société',
    agence: 'Agence',
    regroupementProduit: 'Regr.',
    actif: 'Archivé',
    etat: 'Etat',
  },
  filtre: {
    reference: 'Référence(s)',
    regroupementProduit: 'Regroupement de produit(s)',
    actif: 'Actif',
    ville: 'Ville(s)',
    departement: 'Département(s)',
    format: 'Format(s)',
    materiel: 'Matériel(s)',
    support: 'Support(s)',
    agglomeration: 'Agglomération(s)',
    angleVision: 'Angle(s) de vision',
    codePostal: 'Code postal',
    localisation: 'Localisation(s)',
    agence: 'Agence',
    adresses: 'Adresse(s)',
    societe: 'Société',
    eclaire: 'Eclairé',
    avecLiaisonsTarif: 'Avec produits associés',
    avecCoordonnees: 'Avec Coordonnees GPS',
    errors: {
      dateReferenceAffectation: 'La date de référence d\'affectation est obligatoire',
    },
  },
};

export default LISTE_PRODUIT_ECRAN;
